import { Component, OnInit } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {Cards} from '../cards-mockup';

enum Directions {
  left,
  right
}

@Component({
  selector: 'app-binary-search',
  templateUrl: './binary-search.component.html',
  styleUrls: ['./binary-search.component.css']
})
export class BinarySearchComponent extends GeneralExerciseComponent implements OnInit {

  isInsertExercise: boolean;
  isInsertAllCardsExercise: boolean;

  numberOfTotalCards = 0;
  cards: number[] = [];
  currentLeftIndex: number;
  currentRightIndex: number;
  currentMiddleIndex: number;
  // selectedCard is the card we have to find or for which we have to find the correct position
  selectedCard: number;
  selectedCardShow: boolean;
  currentCompareCard: number;
  stepsCounter = 0;
  directions = Directions;
  // During the animation the user can not click on the buttons
  isButtonDisabled: boolean;

  emptyPlaceholderCard = Cards.length - 1;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.generateNextExercise();
  }

  initValues() {
    this.solved = false;
    this.cards = [];
    this.numberOfTotalCards = 0;
    this.stepsCounter = 0;
  }

  initBinaryValues() {
    this.isButtonDisabled = false;
    this.currentLeftIndex = 0;
    this.currentRightIndex = this.cards.length - 1;
    this.currentMiddleIndex = this.getMiddleIndex();
    this.selectedCard = this.selectCard();
    this.selectedCardShow = true;
    this.currentCompareCard = this.cards[this.currentMiddleIndex];
  }

  checkSolution() {
    if (this.currentCompareCard === this.selectedCard) {
      if (!this.isInsertAllCardsExercise || this.numberOfTotalCards === this.cards.length) {
        let timeoutToInsertCard = 0;
        if (this.isInsertExercise) {
          this.selectedCardShow = false;
          timeoutToInsertCard = 1200;
        }
        setTimeout(() => {
          this.solved = true;
          this.isSolvedImageVisible = true;
          setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
          this.saveState();
        }, timeoutToInsertCard);
      } else {
        this.selectedCardShow = false;
        setTimeout(() => { this.initBinaryValues(); }, 800);
      }
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  generateNextExercise() {
    this.counter++;
    this.initValues();
    this.numberOfTotalCards = this.getNumberOfCards();
    if (this.isInsertAllCardsExercise) {
      this.cards = [Math.floor((Math.random() * 17))];
    } else {
      this.constructSortedCardList();
    }
    this.initBinaryValues();
  }

  /**
   * Select a card for the exercise:
   * For search exercise: return a card (from the list) that the user has to find in the list.
   * For insert exercise: return a card (not in the list) that the user has to insert in the list.
   */
  selectCard() {
    let randCard;
    if (!this.isInsertExercise) {
      const randCardIdx = Math.floor((Math.random() * this.cards.length));
      randCard = this.cards[randCardIdx];
    } else {
      randCard = Math.floor((Math.random() * 16) + 1);
      while (!(this.cards.indexOf(randCard) === -1)) {
        randCard = Math.floor((Math.random() * 17));
      }
    }
    return randCard;
  }

  getMiddleIndex() {
    return Math.floor( (this.currentRightIndex + this.currentLeftIndex) / 2);
  }

  /**
   * The selected card is smaller then the compare cards.
   * Proceed in the left part
   */
  moveLeft() {
    if (this.selectedCard < this.currentCompareCard) {
      this.isButtonDisabled = true;
      this.stepsCounter++;

      // Set time for the timeout
      // If there will be no new grey cards -> 0 seconds to wait, skip the card coloring, no coloring.
      let timeoutToColorGreyCards = 0;
      if (this.currentRightIndex !== this.currentMiddleIndex) {
        timeoutToColorGreyCards = 1200;
      }
      this.currentRightIndex = this.currentMiddleIndex - 1;

      // Insert exercise solved
      const timeout = 1200;
      if (this.isInsertExercise && this.currentRightIndex < this.currentLeftIndex) {
        setTimeout(() => { this.currentCompareCard = -1; }, timeoutToColorGreyCards);
        /*setTimeout(() => {
          this.currentCompareCard = this.emptyPlaceholderCard;
          this.cards.splice(this.currentMiddleIndex, 0, this.emptyPlaceholderCard);
        }, timeoutToColorGreyCards + timeout); */
        setTimeout(() => {
          this.cards.splice(this.currentMiddleIndex, 0, this.selectedCard);
          this.currentCompareCard = this.selectedCard;
          this.checkSolution();
        },  timeoutToColorGreyCards + (1 * timeout));
      } else {
        setTimeout(() => { this.currentCompareCard = -1; }, timeoutToColorGreyCards);
        setTimeout(() => {
          this.currentMiddleIndex = this.getMiddleIndex();
          this.currentCompareCard = this.cards[this.currentMiddleIndex];
          this.isButtonDisabled = false; }, timeoutToColorGreyCards + 1200);
      }
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  canMoveLeft() {
    return (this.getDirectionSize(this.directions.left) > 0 && this.currentLeftIndex < this.currentMiddleIndex) || (this.isInsertExercise);
  }

  /**
   * The selected card is larger then the compare cards.
   * Proceed in the right part
   */
  moveRight() {
    if (this.selectedCard > this.currentCompareCard) {
      this.isButtonDisabled = true;
      this.stepsCounter++;

      // Set time for the timeout
      // If there will be no new grey cards -> 0 seconds to wait, skip the card coloring, no coloring.
      let timeoutToColorGreyCards = 0;
      if (this.currentLeftIndex !== this.currentMiddleIndex) {
        timeoutToColorGreyCards = 1200;
      }
      this.currentLeftIndex = this.currentMiddleIndex + 1;

      // Insert exercise solved
      const timeout = 1200;
      if (this.isInsertExercise && this.currentRightIndex < this.currentLeftIndex) {
        setTimeout(() => { this.currentCompareCard = -1; }, timeoutToColorGreyCards);
        /*setTimeout(() => {
          this.currentCompareCard = this.emptyPlaceholderCard;
          this.cards.splice(this.currentMiddleIndex, 0, this.emptyPlaceholderCard);
        }, timeoutToColorGreyCards + timeout);*/
        setTimeout(() => {
          this.currentMiddleIndex ++;
          this.cards.splice(this.currentMiddleIndex, 0, this.selectedCard);
          this.currentCompareCard = this.selectedCard;
          this.checkSolution();
        }, timeoutToColorGreyCards + (1 * timeout));
      } else {
        setTimeout(() => { this.currentCompareCard = -1; }, timeoutToColorGreyCards);
        setTimeout(() => {
          this.currentMiddleIndex = this.getMiddleIndex();
          this.currentCompareCard = this.cards[this.currentMiddleIndex];
          this.isButtonDisabled = false; }, timeoutToColorGreyCards + 1200);
      }
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  canMoveRight() {
    return (this.getDirectionSize(this.directions.right) > 0 && this.currentRightIndex > this.currentMiddleIndex)
      || (this.isInsertExercise);
  }

  /**
   * Construct an initial list of cards in which we search/insert the selected card
   */
  constructSortedCardList() {
    let i = 0;
    while (i < this.numberOfTotalCards) {
      const randomId = Math.floor((Math.random() * 17));
      // Only use a card once in the list.
      if (this.cards.indexOf(randomId) === -1) {
        this.cards.push(randomId);
        i ++;
      }
    }

    this.cards.sort((a, b) => a - b);
  }

  getNumberOfCards() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 5); // 5 6
    } else if (this.level === 2) {
      return Math.floor((Math.random() * 3) + 7); // 7 8 9
    } else {
      return Math.floor((Math.random() * 3) + 10); // 10 11 12
    }
  }

  getDirectionArray(direction: Directions) {
    if (direction === Directions.left) {
      return Array.from(Array(this.currentMiddleIndex).keys());
    } else {
      const totalRight = Math.max((this.cards.length - 1) - this.currentMiddleIndex, 0);
      return Array.from(Array(totalRight).keys(), x => this.currentMiddleIndex + 1 + x);
    }
  }

  getDirectionSize(direction: Directions) {
    if (direction === Directions.left) {
      return this.currentMiddleIndex;
    } else {
      const totalRight = Math.max((this.cards.length - 1) - this.currentMiddleIndex, 0);
      return totalRight;
    }
  }

  /**
   * 84% of the width is for left and right card lists.
   * here we calculate the width for each direction dependent on the number of cards they contain.
   * @param direction
   */
  getLeftRightSize(direction: Directions) {
    const leftSize = this.getDirectionSize(Directions.left);
    const rightSize = this.getDirectionSize(Directions.right);
    let compareCardSize = parseInt(document.getElementById('compareCard').style.width, 10);

    if (isNaN(compareCardSize)) {
      compareCardSize = 12;
    }
    const cardSize = Math.min((100 - compareCardSize) / ( leftSize + rightSize ), 10);
    if (direction === Directions.left) {
      return cardSize * leftSize;
    } else {
      return cardSize * rightSize;
    }
  }

  getCardImageSrc(cardId: number) {
    // card value === card id
    if (cardId === -1) {
      return './assets/images/cards/cover_grey.png';
    }
    return Cards[cardId].imageSrc;
  }

  getLeftCardImageSrc(index: number) {
    if (this.solved) {
      return Cards[this.cards[index]].imageSrc;
    }
    if (index < this.currentLeftIndex) {
      return './assets/images/cards/cover_grey.png';
    }
    return './assets/images/cards/cover.png';
  }

  getRightCardImageSrc(index: number) {
    if (this.solved) {
      return Cards[this.cards[index]].imageSrc;
    }
    if (index > this.currentRightIndex) {
      return './assets/images/cards/cover_grey.png';
    }
    return './assets/images/cards/cover.png';
  }

  computeState() {
  }

  setTypeSpecificsFromConfiguration() {
    this.isInsertAllCardsExercise = this.configuration.typespecifics.isInsertAllCardsExercise;
    this.isInsertExercise = this.configuration.typespecifics.isInsertExercise;
  }

  setTypeSpecificsFromState() {
  }

  setLevel(level: number) {
    if (level !== this.level) {
      super.setLevel(level);
      this.generateNextExercise();
    }
  }
}

